import React, { useState, useEffect } from "react";
import { Card, Descriptions, Button, Spin, Image, Tag, Space } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useParams, useNavigate } from "react-router-dom";
import { useDynamicApi } from "../../hooks/useApi";
import { API_ENDPOINTS } from "../../config/api";
import Toast from "../../utils/toast";
import { useTranslation } from "react-i18next";

const TipDetailView = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const [tip, setTip] = useState(null);
  const [loading, setLoading] = useState(true);

  const { execute: getTip } = useDynamicApi("GET");

  const fetchTipDetail = async () => {
    setLoading(true);
    try {
      const endpoint = `${API_ENDPOINTS.TIP_SESSIONS_DETAIL_BY_ID}/${id}`;
      const response = await getTip(endpoint);
      if (response?.status === true && response.data) {
        setTip(response.data);
      } else {
        Toast.error(response?.message || t("tipDetail.notFound"));
        navigate("/tips");
      }
    } catch (error) {
      console.error(error);
      Toast.error(t("tipDetail.fetchError"));
      navigate("/tips");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) fetchTipDetail();
  }, [id]);

  const CATEGORY_MAP = {
    COACHING: t("tipCategories.COACHING"),
    TECHNIQUE: t("tipCategories.TECHNIQUE"),
    GAME: t("tipCategories.GAME"),
    YOUTH: t("tipCategories.YOUTH"),
  };

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: 50 }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!tip) return null;

  return (
    <Card
      title={
        <Space>
          <Button
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate("/tip-sessions")}
          >
            {t("common.back")}
          </Button>
          <span>{t("tipDetail.title")}</span>
        </Space>
      }
    >
      <Descriptions bordered column={1} className="description-mainjh">
        <Descriptions.Item label={t("tipManager.title")}>
          {tip.title}
        </Descriptions.Item>
        <Descriptions.Item label={t("tipManager.category")}>
          <Tag color="blue">{CATEGORY_MAP[tip.category] || tip.category}</Tag>
        </Descriptions.Item>
        <Descriptions.Item label={t("tipManager.description")}>
          {tip.description || "N/A"}
        </Descriptions.Item>
        <Descriptions.Item label={t("tipManager.video")}>
          {tip.video_url ? (
            <video controls style={{ maxWidth: "100%", maxHeight: 400 }}>
              <source src={tip.video_url} type="video/mp4" />
              {t("tipDetail.videoNotSupported")}
            </video>
          ) : (
            "N/A"
          )}
        </Descriptions.Item>
        <Descriptions.Item label={t("tipManager.thumbnail")}>
          {tip.thumbnail_url ? (
            <Image src={tip.thumbnail_url} width={200} />
          ) : (
            "N/A"
          )}
        </Descriptions.Item>
        <Descriptions.Item label={t("common.createdAt")}>
          {new Date(tip.created_at).toLocaleString()}
        </Descriptions.Item>
        <Descriptions.Item label={t("common.lastUpdated")}>
          {new Date(tip.updated_at).toLocaleString()}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

export default TipDetailView;
